module.exports = __webpack_public_path__ + "img/12.61e62928.png";